import { render, staticRenderFns } from "./ScoreBoard.vue?vue&type=template&id=a50e6f4e&scoped=true"
import script from "./ScoreBoard.vue?vue&type=script&lang=js"
export * from "./ScoreBoard.vue?vue&type=script&lang=js"
import style0 from "./ScoreBoard.vue?vue&type=style&index=0&id=a50e6f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50e6f4e",
  null
  
)

export default component.exports